import React from 'react';

export default function Legal({ title }) {
  
  // This function decides which text to show based on the page you are on
  const renderContent = () => {
    switch (title) {
      case 'Terms of Service':
        return (
          <>
            <h3>1. Acceptance of Terms</h3>
            <p>By accessing and using Nundinaria, you agree to abide by these Terms of Service. Nundinaria is a peer-to-peer marketplace connecting buyers and sellers of used gear.</p>
            
            <h3>2. User Responsibilities</h3>
            <p>Users must provide accurate information when creating an account. Sellers must accurately describe the condition of their items. Buyers agree to pay for items purchased and communicate respectfully.</p>
            
            <h3>3. Platform Role</h3>
            <p>Nundinaria acts purely as a technology facilitator. We do not take physical ownership of the items sold, nor are we directly involved in the transaction or fulfillment between buyers and sellers beyond providing the platform infrastructure.</p>
            
            <h3>4. Prohibited Items</h3>
            <p>Users may not list illegal, counterfeit, hazardous materials, or any items that violate standard shipping regulations. Nundinaria reserves the right to remove any listing at our discretion.</p>
          </>
        );
      case 'Privacy Policy':
        return (
          <>
            <h3>1. Information We Collect</h3>
            <p>We collect information you provide directly to us, such as your name, email address, and shipping location when you register or make a purchase.</p>
            
            <h3>2. How We Use Your Information</h3>
            <p>We use your information strictly to operate the platform, facilitate transactions between users, and send necessary automated communications (such as purchase receipts and shipping tracking updates).</p>
            
            <h3>3. Third-Party Payment Services</h3>
            <p>We use secure, industry-standard third-party gateways (Stripe and PayPal) to process all financial transactions. Your sensitive financial data (like full credit card numbers) is handled directly by them through encrypted tokens and is never stored on Nundinaria's servers.</p>
          </>
        );
      case 'Refund Policy':
        return (
          <>
            <h3>1. Standard Sales Policy</h3>
            <p>Because Nundinaria is a peer-to-peer marketplace, all sales are considered final once the seller has shipped the item and provided a tracking number.</p>
            
            <h3>2. Buyer Protection</h3>
            <p>If an item arrives significantly damaged or is completely different than described in the listing, buyers must contact the seller via the Nundinaria messaging system within 48 hours of delivery to seek a mutually agreed resolution.</p>
            
            <h3>3. Dispute Resolution</h3>
            <p>If a buyer and seller cannot reach an agreement, official financial disputes are handled directly through our payment processors (Stripe or PayPal) utilizing their standard Buyer Protection frameworks.</p>
          </>
        );
      default:
        return <p>Content not found.</p>;
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '40px', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
      <h1 style={{ borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '20px' }}>
        {title}
      </h1>
      
      <div style={{ color: '#444', lineHeight: '1.6' }}>
        {renderContent()}
      </div>

      <p style={{ marginTop: '40px', fontSize: '12px', color: '#888', textAlign: 'center', borderTop: '1px solid #eee', paddingTop: '20px' }}>
        Last Updated: {new Date().toLocaleDateString()}
      </p>
    </div>
  );
}